"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVATE_PACKAGE_RESPONSE_EXAMPLE = void 0;
const financial_common_response_1 = require("./financial-common.response");
exports.ACTIVATE_PACKAGE_RESPONSE_EXAMPLE = {
    package: financial_common_response_1.FIN_PACKAGE_RESPONSE_EXAMPLE,
    notificationSent: false,
};
//# sourceMappingURL=financial-package.response.js.map